import { PROD_DOMAIN_PATTERNS } from './constants';
import { Region } from './types';

export const resolveRegionFromHost = (host: string): Region | undefined => {
  if (!host) return undefined;
  const loweredHost = host.toLowerCase();

  const match = PROD_DOMAIN_PATTERNS.find(({ suffix }) => loweredHost.endsWith(suffix));
  return match?.region;
};

export const isMappedProductionHost = (host: string): boolean => {
  return !!resolveRegionFromHost(host);
};
